import { Table, Spin } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { translate } from "utils";
import useColumn from "./useColumn";
import {
	getListSubscriptionTransactionAsync,
	selectSubscriptionTransactionList,
} from "features/subscription-transaction/redux/subscription-transaction.slice";
import { SubscriptionTransactionQueryParams } from "features/subscription-transaction/type";
import { useParams } from "react-router-dom";
import Search from "./Search";
import {
	selectSubscriptionTransactionFilter,
	setSubscriptionTransactionFilter,
} from "store/filter/index.slice";
type Props = {
	isShowSearch?: boolean;
};

export default function SubscriptionBillingInfor({ isShowSearch }: Props) {
	const dispatch = useDispatch();
	const { id = "" } = useParams();
	const { items, total } = useSelector(selectSubscriptionTransactionList);
	const query = useSelector(selectSubscriptionTransactionFilter);
	const setQuery = (newQuery?: SubscriptionTransactionQueryParams) =>
		dispatch(setSubscriptionTransactionFilter(newQuery));
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		if (id) {
			setQuery({ skip: 0, take: 10, merchantId: id });
		}
		getList();
	}, [id]);

	const getList = (newQuery?: SubscriptionTransactionQueryParams) => {
		setIsLoading(true);
		let _query = newQuery || query;
		if (id) {
			_query = { ...query, merchantId: Number(id) };
		}
		if (
			(_query.createdAtFrom && _query.createdAtTo) ||
			(!_query.createdAtFrom && !_query.createdAtTo)
		) {
			dispatch(
				getListSubscriptionTransactionAsync({
					query: _query,
					callback: () => setIsLoading(false),
				}),
			);
		} else {
			setIsLoading(false);
		}
	};

	const handleChangePage = (page: number) => {
		const newQuery = { ...query, skip: page - 1 };
		getList(newQuery);
	};

	const handlePageSizeChange = (current: number, size: number) => {
		setTimeout(() => {
			const newQuery = { ...query, skip: 0, take: size };
			getList(newQuery);
		}, 0);
	};

	return (
		<Spin spinning={isLoading}>
			{isShowSearch && (
				<Search query={query} setQuery={setQuery} getList={getList} />
			)}
			<Table
				className="mt-5"
				dataSource={items}
				bordered
				scroll={{ x: 1200 }}
				columns={useColumn({ query })}
				rowKey={record => record.id}
				pagination={{
					pageSizeOptions: ["5", "10", "20", "50"],
					total: total,
					current: query.skip + 1,
					pageSize: query.take,
					showSizeChanger: true,
					showTotal: total =>
						translate("Total") + " " + total + " " + translate("results"),
					onChange: handleChangePage,
					onShowSizeChange: handlePageSizeChange,
				}}
				locale={{
					emptyText: (
						<span className="text-gray-8">{translate("No data")}</span>
					),
				}}
			/>
		</Spin>
	);
}
